import classnames from 'classnames';
import { useField } from 'formik';
import { FC } from 'react';
import { BaseField } from '../Base';
import { TextAreaProps } from './types';

export const TextArea: FC<TextAreaProps> = ({ name, ...rest }) => {
  const [field, meta] = useField<string>(name);

  return (
    <BaseField meta={meta}>
      <textarea
        {...rest}
        className={classnames('form-control', {
          'is-invalid': meta.touched && Boolean(meta.error),
        })}
        name={name}
        value={meta.value}
        onChange={field.onChange}
        onBlur={field.onBlur}
      >
        {meta.value}
      </textarea>
    </BaseField>
  );
};
